import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-2 gap-4"
          >
            <img 
              src="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
              alt="Sustainable forest" 
              className="rounded-2xl w-full h-64 object-cover transform translate-y-8"
            />
            <img 
              src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
              alt="Global network" 
              className="rounded-2xl w-full h-64 object-cover"
            />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-primary font-bold tracking-wider uppercase mb-2">About CoxCred</h2>
            <h3 className="text-4xl font-extrabold text-teal-950 mb-6 leading-tight">
              Dedicated to a Greener, <br/> Healthier Planet
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              CoxCred is dedicated to helping organizations achieve their Net Zero Carbon goals through trusted carbon credit solutions, sustainability consultancy, and environmental responsibility strategies.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Driven by innovation, transparency, and commitment to sustainability, CoxCred empowers businesses to turn climate responsibility into meaningful action for future generations.
            </p>
            
            <div className="grid grid-cols-2 gap-6 border-t border-gray-100 pt-8">
              <div>
                <p className="text-4xl font-black text-accent mb-2">10+</p>
                <p className="text-sm font-semibold text-gray-800 uppercase tracking-wide">Years Experience</p>
              </div>
              <div>
                <p className="text-4xl font-black text-accent mb-2">500+</p>
                <p className="text-sm font-semibold text-gray-800 uppercase tracking-wide">Projects Supported</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
